import { FC } from 'react';
import { ILinkButton } from './link-button.props';
import { StyledLinkButton } from '../button.styled';
import { ShiftBy } from '../../shift-by';
import { Spinner } from '../../spinner';
import { cmsUrlWithoutSiteId } from '../../../../utils/helpers';

export const LinkButton: FC<ILinkButton> = ({
    className,
    children,
    showAsBlock = false,
    variant = 'light',
    loading = false,
    alignSelf,
    unsetMinWidth = false,
    target,
    href,
    isExternal,
    onClick,
}) => {
    return (
        <StyledLinkButton
            href={isExternal ? href : cmsUrlWithoutSiteId(href)}
            target={target || '_self'}
            className={className}
            variant={variant}
            showAsBlock={showAsBlock}
            alignment={alignSelf}
            unsetMinWidth={unsetMinWidth}
            onClick={(e) => {
                e.stopPropagation();
                onClick?.();
            }}
        >
            {loading && (
                <ShiftBy x={-4} y={2}>
                    <Spinner size="small" variant={variant} />
                </ShiftBy>
            )}
            {children}
        </StyledLinkButton>
    );
};
